angular.module('vastdesk').
  component('imaVastPlayer', {
    bindings: {
      playerId: '@',
      vastUrl: '@'
    },
    template: '<div class="ima-player-container">' +
              '<video id="{{$imaVastPlayerCtrl.playerId}}-content" class="ima-content-player" playsinline muted></video>' +
              '<div id="{{$imaVastPlayerCtrl.playerId}}-ad-container" class="ima-ad-container"></div>' +
              '<div class="ima-click-interceptor" ng-class="{\'ima-ad-paused\': $imaVastPlayerCtrl.adPaused}" ng-show="!$imaVastPlayerCtrl.showPlayButton" ng-click="$imaVastPlayerCtrl.onAdClick()"></div>' +
              '<div class="ima-bottom-controls" ng-show="!$imaVastPlayerCtrl.showPlayButton">' +
                '<div class="ima-progress-bar" ng-class="{\'ima-is-dragging\': $imaVastPlayerCtrl.isDragging}">' +
                  '<div class="ima-progress-bar-track">' +
                    '<div class="ima-progress-bar-fill" ng-style="{width: $imaVastPlayerCtrl.adProgress + \'%\'}"></div>' +
                  '</div>' +
                  '<input type="range" class="ima-progress-input" min="0" max="100" step="0.1" ng-model="$imaVastPlayerCtrl.adProgress" ng-mousedown="$imaVastPlayerCtrl.onProgressDragStart()" ng-change="$imaVastPlayerCtrl.onProgressChange()" aria-label="Ad progress">' +
                '</div>' +
                '<div class="ima-controls-bar">' +
                  '<div class="ima-controls-left">' +
                    '<button type="button" class="ima-volume-button" ng-class="{\'ima-muted\': $imaVastPlayerCtrl.isMuted}" ng-click="$imaVastPlayerCtrl.toggleMute()" aria-label="Toggle mute"></button>' +
                    '<input type="range" class="ima-volume-slider" min="0" max="1" step="0.05" ng-model="$imaVastPlayerCtrl.volume" ng-change="$imaVastPlayerCtrl.onVolumeChange()">' +
                  '</div>' +
                  '<div class="ima-controls-right">' +
                    '<button type="button" class="ima-fullscreen-button" ng-class="{\'ima-fullscreen-active\': $imaVastPlayerCtrl.isFullscreen}" ng-click="$imaVastPlayerCtrl.toggleFullscreen()" aria-label="Toggle fullscreen"></button>' +
                  '</div>' +
                '</div>' +
              '</div>' +
              '<button type="button" class="ima-play-button" ng-show="$imaVastPlayerCtrl.showPlayButton" ng-click="$imaVastPlayerCtrl.onPlayClick()" aria-label="Play ad preview"></button>' +
              '</div>',
    controllerAs: '$imaVastPlayerCtrl',
    controller: ['$timeout', '$element', function($timeout, $element) {

      var self = this;
      var adsManager;
      var adsLoader;
      var adDisplayContainer;
      var resizeTimeout;
      var isDragging = false;

      self.showPlayButton = true;
      self.adPaused = false;
      self.adProgress = 0;
      self.isDragging = false;
      self.isFullscreen = false;
      self.isMuted = true;
      self.volume = 1;

      var onWindowResize = function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
          if (!adsManager) return;
          var videoElement = document.getElementById(self.playerId + '-content');
          if (!videoElement) return;
          adsManager.resize(videoElement.clientWidth, videoElement.clientHeight, google.ima.ViewMode.NORMAL);
        }, 100);
      };

      var onFullscreenChange = function() {
        var isNowFullscreen = !!(document.fullscreenElement || document.webkitFullscreenElement);
        $timeout(function() {
          self.isFullscreen = isNowFullscreen;
        });
        if (!adsManager) return;
        if (isNowFullscreen) {
          adsManager.resize(window.innerWidth, window.innerHeight, google.ima.ViewMode.FULLSCREEN);
        } else {
          var videoElement = document.getElementById(self.playerId + '-content');
          var w = videoElement ? videoElement.clientWidth || 640 : 640;
          var h = videoElement ? videoElement.clientHeight || 360 : 360;
          adsManager.resize(w, h, google.ima.ViewMode.NORMAL);
        }
      };

      window.addEventListener('resize', onWindowResize);
      document.addEventListener('fullscreenchange', onFullscreenChange);
      document.addEventListener('webkitfullscreenchange', onFullscreenChange);

      var hasVastUrl = function() {
        return self.vastUrl &&
          self.vastUrl !== 'undefined' &&
          self.vastUrl !== 'null';
      };

      // Upgrades http:// to https:// so the browser's mixed-content policy
      // does not block ad tag requests on HTTPS pages.
      var normalizeVastUrl = function(url) {
        return url.replace(/^http:\/\//i, 'https://');
      };

      var resetPlayer = function() {
        $timeout(function() {
          self.showPlayButton = true;
          self.adPaused = false;
          self.adProgress = 0;
          self.isFullscreen = false;
        });
      };

      var onProgressDragEnd = function() {
        if (!isDragging) return;
        isDragging = false;
        $timeout(function() {
          self.isDragging = false;
        });
      };

      document.addEventListener('mouseup', onProgressDragEnd);
      document.addEventListener('touchend', onProgressDragEnd);

      var onAdProgress = function(adEvent) {
        if (isDragging) return;
        var data = adEvent.getAdData();
        if (data.duration > 0) {
          $timeout(function() {
            self.adProgress = (data.currentTime / data.duration) * 100;
          });
        }
      };

      var onAdsManagerLoaded = function(adsManagerLoadedEvent) {
        var videoElement = document.getElementById(self.playerId + '-content');
        adsManager = adsManagerLoadedEvent.getAdsManager(videoElement);

        adsManager.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, onAdError);
        adsManager.addEventListener(google.ima.AdEvent.Type.AD_PROGRESS, onAdProgress);
        adsManager.addEventListener(google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED, onContentResumeRequested);
        adsManager.addEventListener(google.ima.AdEvent.Type.ALL_ADS_COMPLETED, onAllAdsCompleted);

        try {
          var width = videoElement ? videoElement.clientWidth || 640 : 640;
          var height = videoElement ? videoElement.clientHeight || 360 : 360;
          adsManager.init(width, height, google.ima.ViewMode.NORMAL);
          adsManager.setVolume(self.isMuted ? 0 : parseFloat(self.volume));
          adsManager.start();
        } catch (adError) {
          resetPlayer();
        }
      };

      var onAdError = function() {
        if (adsManager) {
          adsManager.destroy();
          adsManager = null;
        }
        resetPlayer();
      };

      var onContentResumeRequested = function() {
        if (adsManager) {
          adsManager.destroy();
          adsManager = null;
        }
        resetPlayer();
      };

      var onAllAdsCompleted = function() {
        if (adsManager) {
          adsManager.destroy();
          adsManager = null;
        }
        resetPlayer();
      };

      // Intercepts clicks on the playing ad to toggle pause/resume rather than
      // following the VAST click-through URL and navigating away from the page.
      self.onAdClick = function() {
        if (!adsManager) return;
        if (self.adPaused) {
          adsManager.resume();
          self.adPaused = false;
        } else {
          adsManager.pause();
          self.adPaused = true;
        }
      };

      self.onProgressDragStart = function() {
        isDragging = true;
        self.isDragging = true;
      };

      // IMA SDK has no seek API for VAST ads, so we seek the underlying ad
      // video element directly. Works for standard MP4 ads; no-ops otherwise.
      self.onProgressChange = function() {
        if (!isDragging) return;
        var adVideo = document.querySelector('#' + self.playerId + '-ad-container video');
        if (adVideo && adVideo.duration && !isNaN(adVideo.duration)) {
          adVideo.currentTime = (parseFloat(self.adProgress) / 100) * adVideo.duration;
        }
      };

      self.toggleMute = function() {
        if (!adsManager) return;
        self.isMuted = !self.isMuted;
        adsManager.setVolume(self.isMuted ? 0 : parseFloat(self.volume));
      };

      self.onVolumeChange = function() {
        if (!adsManager) return;
        var vol = parseFloat(self.volume);
        self.isMuted = (vol === 0);
        adsManager.setVolume(vol);
      };

      self.toggleFullscreen = function() {
        var container = $element[0].querySelector('.ima-player-container');
        if (!document.fullscreenElement && !document.webkitFullscreenElement) {
          if (container.requestFullscreen) {
            container.requestFullscreen();
          } else if (container.webkitRequestFullscreen) {
            container.webkitRequestFullscreen();
          }
        } else {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
          }
        }
      };

      self.onPlayClick = function() {
        if (!hasVastUrl() || typeof google === 'undefined' || !google.ima) {
          return;
        }

        self.showPlayButton = false;

        var videoElement = document.getElementById(self.playerId + '-content');
        var adContainerEl = document.getElementById(self.playerId + '-ad-container');

        if (!videoElement || !adContainerEl) {
          self.showPlayButton = true;
          return;
        }

        // Fully reinitialize on each play. Clearing the container DOM and
        // recreating AdDisplayContainer + AdsLoader avoids stale state from
        // the previous session that would silently block replay.
        adContainerEl.innerHTML = '';

        adDisplayContainer = new google.ima.AdDisplayContainer(adContainerEl, videoElement);
        adDisplayContainer.initialize();

        adsLoader = new google.ima.AdsLoader(adDisplayContainer);
        adsLoader.addEventListener(
          google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED,
          onAdsManagerLoaded,
          false
        );
        adsLoader.addEventListener(
          google.ima.AdErrorEvent.Type.AD_ERROR,
          onAdError,
          false
        );

        var adsRequest = new google.ima.AdsRequest();
        adsRequest.adTagUrl = normalizeVastUrl(self.vastUrl);
        adsRequest.linearAdSlotWidth = videoElement.clientWidth || 640;
        adsRequest.linearAdSlotHeight = videoElement.clientHeight || 360;
        adsLoader.requestAds(adsRequest);
      };

      this.$onDestroy = function() {
        window.removeEventListener('resize', onWindowResize);
        document.removeEventListener('fullscreenchange', onFullscreenChange);
        document.removeEventListener('webkitfullscreenchange', onFullscreenChange);
        document.removeEventListener('mouseup', onProgressDragEnd);
        document.removeEventListener('touchend', onProgressDragEnd);
        clearTimeout(resizeTimeout);
        if (adsManager) {
          adsManager.destroy();
        }
        if (adsLoader) {
          adsLoader.destroy();
        }
      };

    }]
  });
